import { Injectable } from '@angular/core';
import { filter, Subject } from 'rxjs';
import { Message } from './message';

@Injectable({
  providedIn: 'root'
})
export class PubsubService {

  constructor() { }

  private pubs$ = new Subject<Message>();

  publish(message: Message) {
    this.pubs$.next(message);
  }

  subscribe(message: string) {
    return this.pubs$.pipe(filter(m => m.name === message));
  }

}
